import React, { useEffect, useState, useRef } from "react";
import FormAddCourse from "./PageAdmin/FormAddCourse";
import styled from "styled-components";

const PageContainer = styled.div`
  min-height: 100vh;
  background: #f4f6fa;
  padding: 2rem 0;
`;
const CoursesSection = styled.div`
  max-width: 900px;
  margin: 2rem auto 0 auto;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  padding: 2rem 2rem 1rem 2rem;
`;
const SectionTitle = styled.h3`
  color: #2d3748;
  margin-bottom: 1.2rem;
`;
const CoursesTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fff;
`;
const Th = styled.th`
  text-align: left;
  padding: 0.75rem 0.5rem;
  background: #f7fafc;
  color: #4a5568;
  border-bottom: 2px solid #e2e8f0;
`;
const Td = styled.td`
  padding: 0.6rem 0.5rem;
  border-bottom: 1px solid #edf2f7;
  color: #2d3748;
`;

const PageAddCourse = () => {
  const [courses, setCourses] = useState([]);
  const formRef = useRef();

  // Fetch courses from backend
  const fetchCourses = async () => {
    try {
      const res = await fetch(process.env.REACT_APP_API_URL + "/course");
      const data = await res.json();
      setCourses(data.courses || []);
    } catch (err) {
      setCourses([]);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  // Listen for successful add to refresh list
  const handleCourseAdded = () => {
    fetchCourses();
  };

  return (
    <PageContainer>
      <FormAddCourse onCourseAdded={handleCourseAdded} ref={formRef} />
      <CoursesSection>
        <SectionTitle>All Courses</SectionTitle>
        <CoursesTable>
          <thead>
            <tr>
              <Th>ID</Th>
              <Th>Title</Th>
              <Th>Item</Th>
              <Th>Data</Th>
              <Th>Image</Th>
            </tr>
          </thead>
          <tbody>
            {courses.length === 0 ? (
              <tr><Td colSpan={4} style={{textAlign:'center'}}>No courses available.</Td></tr>
            ) : (
              courses.map((c, idx) => (
                <tr key={c.course_id || idx}>
                  <Td>{c.course_id}</Td>
                  <Td>{c.course_title}</Td>
                  <Td>{c.course_item}</Td>
                  <Td>{c.course_data}</Td>
                  <Td>{c.course_image ? <img src={c.course_image} alt="course" style={{maxWidth:60,maxHeight:40,borderRadius:4}} /> : <span style={{color:'#aaa'}}>—</span>}</Td>
                </tr>
              ))
            )}
          </tbody>
        </CoursesTable>
      </CoursesSection>
    </PageContainer>
  );
};

export default PageAddCourse;
